import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { SopStep } from "../../Models";
import { PHBHPLayoutPackageService } from "../../../../ph-bhp-layout-package/lib/ph-bhp-layout-package.service";
import { TranslateService } from "@ngx-translate/core";
import { of } from 'rxjs';

@Component({
  selector: 'lib-ph-bhp-step-list',
  templateUrl: './step-list.component.html',
  styleUrls: ['./step-list.component.css']
})
export class StepListComponent implements AfterViewInit {

  width: number;
  columns: number;
  @Input() sopStepsList: Array<SopStep>;

  @Input() isDesktop: boolean;

  @Input() blockCAChanges: boolean;

  @Output() editStepAtIndexClicked = new EventEmitter<EditStepClickedEvent>();

  @Output() addStepAtIndexClicked = new EventEmitter<number | 'atEnd'>();

  /**
   * A list of elements containing the individual steps. These elements are used to get position information for popups.
   */
  @ViewChildren('positioningTarget') positioningTargets: QueryList<ElementRef<HTMLElement>>;
  @ViewChild('stepContainer',{static:false}) stepListContainer: ElementRef;

  constructor(
    public layoutService: PHBHPLayoutPackageService,
    public translate: TranslateService,
  ) {
   
  }
  ngAfterViewInit(): void {
    this.width = this.stepListContainer.nativeElement.offsetWidth  - 95; // 95 is the padding of the container- 1 for the border
    this.columns = Math.floor(this.width/310);
  }

  editStep(event, index: number, step:any ) {
    if(this.blockCAChanges) return;
    // TODO reimplement step editor popup, so that it does not rely on calculated positioning

    // find the correct element for this item
    // this is a workaround to position the step editor (popup) _below_ the correct element
    // QueryList does not yet support .get(i) in the current Angular version, so we use find
    let counterElementsHeight = 0;
    const target = this.positioningTargets.find((_, i) =>  {
      if(this.stepListContainer.nativeElement.offsetWidth < 620 ) {
        counterElementsHeight += _.nativeElement.offsetHeight;
      } else if( this.stepListContainer.nativeElement.offsetWidth >= 620 && this.stepListContainer.nativeElement.offsetWidth <= 669 || this.stepListContainer.nativeElement.offsetWidth <= 929) {
        if(i%2 === 0) {
          counterElementsHeight += _.nativeElement.offsetHeight;
        }
      } else if( this.stepListContainer.nativeElement.offsetWidth >= 930 && this.stepListContainer.nativeElement.offsetWidth <= 1239) {
        if(i%3 === 0) {
          counterElementsHeight += _.nativeElement.offsetHeight;
        }
      } else if( this.stepListContainer.nativeElement.offsetWidth >= 1240) {
        if(i%4 === 0) {
          counterElementsHeight += _.nativeElement.offsetHeight;
        }
      }

      return i === index
    });

    this.editStepAtIndexClicked.emit({
      stepIndex: index,
      elementOffsetTop: counterElementsHeight,// target.nativeElement.offsetTop,
      elementOffsetLeft: target.nativeElement.offsetLeft,
      step: step
    });
  }

  addStepBeforeIndex(index: number) {
    if(this.blockCAChanges) return;
    this.addStepAtIndexClicked.emit(index);
  }
  addStepAtEnd() {
    if(this.blockCAChanges) return;
    this.addStepAtIndexClicked.emit('atEnd');
  }

  errImg(e:Event){
    e.target['src'] = 'assets/img/fallback-img.png';
  }

  verticalPosition(i){
    return i % this.columns != 0 ? {'height': '90%', 'top': '11%', 'left': '53%'} : {}
  }

  shouldShowRightLine(index: number): boolean {
    this.width = this.stepListContainer.nativeElement.offsetWidth; 
    this.columns = Math.floor(this.width/310);
    if((index+1)%4 == 0 && index != 0 && this.columns > 4){
      return false;
    }

    if(this.columns > 4) { this.columns = 4}
    const isOneColumn = this.columns == 1;
    const isLastItem = index == this.sopStepsList.length - 1;
    const isFirstItem = index == 0 && this.sopStepsList.length > 1;
    const isColumnStart = index % this.columns == 0 && this.columns <=4;
    const isWithinColumn = (index + 1) % this.columns > 0 && (index + 1) % this.columns < this.columns;
  
    return !isOneColumn && !isLastItem && (isFirstItem || isColumnStart || isWithinColumn);
  }

  shouldShowBottomRowLine(index: number): boolean {
    this.width = this.stepListContainer.nativeElement.offsetWidth; 
    this.columns = Math.floor(this.width/310);

    if((index+1)%4 == 0 && index != 0 && this.columns > 4){
      return false;
    }
    if(this.columns > 4) { this.columns = 4}

    // last row complete
    if((((this.sopStepsList.length%this.columns) == 0) && ((index+1) > (this.sopStepsList.length-this.columns))) 
        || ((index+1) > (this.sopStepsList.length-(this.sopStepsList.length%this.columns)))) return false;   

    // last row complete
    if(((this.sopStepsList.length%this.columns) == 0) && ((index+1) > (this.sopStepsList.length-this.columns))) return false;   
    
    const isOneColumn = this.columns == 1;
    const isLastItem = index == this.sopStepsList.length - 1;
    const isFirstItem = index == 0 && this.sopStepsList.length > 1;
    const isColumnStart =  index % this.columns == 0 && this.columns <=4;
    const isWithinColumn = (index + 1) % this.columns > 0 && (index + 1) % this.columns < this.columns;
  
    return !isOneColumn && !isLastItem && (isFirstItem || isColumnStart || isWithinColumn);
  }

  shouldShowVerticalUpLine(index: number): boolean {
    if(this.sopStepsList.length == 1) return false;
    this.width = this.stepListContainer.nativeElement.offsetWidth; 
    this.columns = Math.floor(this.width/310);
    if(this.columns > 4) { this.columns = 4}
    const isFirstPosition = index % this.columns === 0;
    if(this.columns==1 && index == 0 && this.sopStepsList.length>1) return false; // first card
    if(this.columns==1 && index == this.sopStepsList.length - 1) return true; // last card
    if(((index+1) == this.sopStepsList.length) && (this.sopStepsList.length%this.columns)==1) return true;
    return (isFirstPosition) && index != 0 && index !== this.sopStepsList.length - 1;  
  }

  shouldShowVerticalDownLine(index: number): boolean {
    this.width = this.stepListContainer.nativeElement.offsetWidth;
    this.columns = Math.floor(this.width/310);
    if(this.columns > 4) { this.columns = 4}
    const isFinalPosition = (index + 1) % this.columns === 0;
    if(this.columns==1 && index == 0 && this.sopStepsList.length>1) return true; // first card
    if((this.columns==1 && index == this.sopStepsList.length - 1) || (index+1)==this.sopStepsList.length) return false; // last card
    if((index+1) == (this.sopStepsList.length - (this.sopStepsList.length%this.columns))) return true; // alone card in last row
    return (isFinalPosition) && index != 0 && index !== this.sopStepsList.length - 1;  
  }

  calcColumns(i, stepsLenght) {
    let width = this.stepListContainer.nativeElement.offsetWidth ;
    let columns = Math.floor(width/310);
    return (i % columns == (columns-1)) && !(i == stepsLenght - 1)
  }

  onResize(event) {
    this.width = this.stepListContainer.nativeElement.offsetWidth ;
    this.columns = Math.floor(this.width/310);
  }

}

// TODO consider changing step editor UI, so that it does not rely on custom positioning values and remove these fields.
export interface EditStepClickedEvent {
  stepIndex: number;
  /**
   * Top offset of the clicked element. Used to position step editor popup.
   */
  elementOffsetTop: number;
  /**
   * Left offset of the clicked element. Used to position step editor popup (arrow).
   */
  elementOffsetLeft: number;
  /**
  * Ref to step for valdiation (the main validtion process maded in parent component)
  */
  step: any;
}
